import React from 'react';
import { useState, useEffect } from 'react';

import { Image, Container, Stack, Row, Col } from 'react-bootstrap';

import homecompetition from './images/arml-1.jpg';

import hmmt_2024 from './images/2024-hmmt.jpg';
import arml_2024 from './images/2024-arml.jpg';

import Sections from './helpers/sections';
import AlternatingImages from './helpers/alternatingimages';
import LeaderSection from './helpers/LeaderSection';
import Discord from './helpers/DiscordSection';
import desc from './helpers/descriptions';
import PageTemplate from './helpers/pagetemp';

function Myhome() {

  var about_us_sections = [
    <>
      <div className="spacious-text">{desc.AboutUs}
      </div>
    </>
  ]

  var why_join_sections = [
    <>
      <div className="spacious-text">{desc.WhyJoin}
      </div>
    </>
  ]

  function Clickable({ href, children }) {
    return (
      <span className="clickable" onClick={() => window.location.href = href}>
        {children}
      </span>
    );
  }

  var competition_sections = AlternatingImages({
    sections: [
      {
        "title": <Clickable href="/arml">ARML</Clickable>,
        "description": <p>{desc.ARML}</p>,
        "image": arml_2024
      },
      {
        "title": <Clickable href="/hmmt">HMMT</Clickable>,
        "description": <p>{desc.HMMT}</p>,
        "image": hmmt_2024
      },
      {
        "title": <Clickable href="/other">Other</Clickable>,
        "description": <p>Over the past years, we have participated in several other competitions as well, including the Online Monmouth Math Competition and the ARML Local competition. </p>,
        "image": homecompetition
      }
    ],
    key: 'competition-desc'
  });

  var sections = [
    {
      "title": "About Us",
      "items": about_us_sections,
    },
    {
      "title": "Why Join?",
      "items": why_join_sections,
    },
    {
      "title": "Competitions",
      "items": competition_sections
    },
    {
      "title": "Meet our Leaders",
      "items": [<LeaderSection />]
    }, 
    {
      "title": "Join Our Discord!", 
      "items": [<Discord />]
    }
  ];

  return <>
    <div id='home-page'>
      <PageTemplate id="home-page-body">
        <Sections sections={sections} />
        <div style={{ height: '60px' }}></div>
      </PageTemplate>
    </div>
  </>
}

function Mylanding() {
  return <div id="landing" key="home-landing">
    <Container className="landing-container">
      <div className="landing-logo-wrapper">
        <div className="landing-logo-container">
          <Image
            src="logo/OMCLOGO.png"
            alt="Oregon Math Circle"
            className="landing-logo-image white-border cirular"
          />
        </div>
      </div>

      <div>
        <Stack gap={1} className="mb-5 px-3">
          <h1 className="text-center landing-welcome-title">Oregon Math Circle</h1>
          <p className="text-center landing-description">An Oregon-wide club for high school students interested in math.</p>
          <div className="text-center mt-2">
            <a href="/join" className="landing-join-button">
              Officially join today!
            </a>
          </div>
        </Stack>
      </div>
    </Container>
  </div>
}

export { Myhome, Mylanding };
